export default __webpack_public_path__ + "static/ai-consultancy-2-a297a5171bdb4d2180862113b00bca54.png";